<div *ngIf="
        organisationService && organisationService.activeItem && certification
    " class="two-columns">
    <div>
        <h1>Zertifizierung anlegen</h1>
        <div class="mini-grid-product-type">
            <mat-form-field>
                <input matInput placeholder="Zertifizierungsstelle"
                    [value]="organisationService.activeItem.organisationName" disabled />
            </mat-form-field>
            <mat-form-field>
                <mat-select name="certificationCategory" placeholder="Produktkategorie"
                    [(ngModel)]="certification.category" required>
                    <mat-option [value]="'1'">Zertifizierung</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <form #form="ngForm">
            <mat-form-field class="fullWidth product-name"
                hintLabel="Keine schon vorhandenen Zertifizierungsnamen oder Sonderzeichen">
                <input matInput [(ngModel)]="certification.name" placeholder="Zertifizierungsname"
                    name="certificationName" required #certificationName="ngModel" />
                <mat-error *ngIf="
                        certificationName.errors?.required &&
                        certificationName.touched
                    ">
                    Bitte geben Sie einen Zertifizierungsnamen ein.
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="Zertifizierungstyp" name="certificationType"
                    [(ngModel)]="certification.certificationType" required>
                    <mat-option [value]="1">Merkmale</mat-option>
                    <mat-option [value]="2">Produkttyp</mat-option>
                    <mat-option [value]="0">Toolchain</mat-option>
                    <mat-option [value]="3">Unternehmens Ontologie</mat-option>
                </mat-select>
            </mat-form-field>
            <app-text-editor [(editorText)]="certification.description"
                (textValidityChange)="onDescriptionValidityChange($event)"></app-text-editor>
            <mat-form-field class="fullWidth url">
                <input matInput [(ngModel)]="certification.url" placeholder="URL" name="url" />
            </mat-form-field>

            <div>
                <p>
                    <em>
                        Zum Anlegen einer Zertifizierung ist das Anlegen einer
                        Variante sowie einer dazugehörigen Version notwendig
                    </em>
                </p>
                <div>
                    <mat-form-field class="fullWidth">
                        <input matInput placeholder="Variantenname" name="variantName" #variantName="ngModel"
                            [(ngModel)]="
                                certification.certificationVariants[0].name
                            " required />
                        <mat-error *ngIf="
                                variantName.errors?.required &&
                                variantName.touched
                            ">
                            Bitte geben Sie einen Variantennamen ein.
                        </mat-error>
                    </mat-form-field>
                </div>
                <app-version-edit [version]="
                        certification.certificationVariants[0]
                            .certificationVariantVersions[0]
                    " [dataType]="'CERTIFICATION'" (validityChanged)="onValidityChanged($event)"></app-version-edit>
                <ng-container *ngIf="certification.certificationType === 3 || certification.certificationType === '3'">
                    <app-certification-template-editor
                        [(shapeJson)]="certification.shape"></app-certification-template-editor>
                </ng-container>
            </div>
            <div class="mini-grid-buttons">
                <button id="savebtn" mat-raised-button class="btn_green" [disabled]="
                        !isFormValid ||
                        !isInputValid() ||
                        form.invalid ||
                        !isDescriptionValid
                    " (click)="createCertification()" color="primary">
                    Speichern
                </button>
                <button mat-raised-button class="btn_red" (click)="cancelCreateCertification()" color="primary">
                    Abbrechen
                </button>
            </div>
        </form>
    </div>

    <div>
        <app-logo [fileId]="certification.fileId" (logoChanged)="certification.fileId = $event"></app-logo>
        <app-product-files [documentFileIds]="certification.documentFileIds"
            [galleryFileIds]="certification.galleryFileIds" [logoId]="certification.fileId"
            [galleryTitle]="'Zertifizierungsgalerie'" (logoChanged)="certification.fileId = $event"></app-product-files>
    </div>
</div>